/* 
 * Développé par la société Précurseur.
 @copyright  Copyright (c) Précurseur
 @link       https://www.precurseur.fr
 */
import * as bootstrap from 'bootstrap';
import $ from 'jquery';

export default class SectorMap {

    constructor(
        id = 'hd-sector-map'
        ) {
    
        this.container = $('#'+id);
        this.popoverDatas = [];
        this.popoverInstances = [];
        var that = this;
        
        if(this.container.length) {
            
            var datas = JSON.parse(this.container.attr('data-popovers'));

            for (var index in datas) { 
                
                var selector = '#'+datas[index]['selector'];
                this.popoverDatas[selector] = datas[index];
                
                if ($(selector).length) {
                    var options = {
                        'container': '#'+id,
                        'content': datas[index]['content'],
                        'title': datas[index]['title'],
                        'html': true,
                        'trigger': 'focus click hover',
                        'customClass': datas[index]['css'],     
                        'offset': datas[index]['offset'],
                        'placement': datas[index]['placement']
                    };
                    
                    new bootstrap.Popover(selector, options);
                    
                    $(selector).on('click', function (evt) {
                        var currentSelector = '#'+$(this).attr('id');
                        $('.sector-active').not(currentSelector).each(function() {
                                bootstrap.Popover.getInstance('#'+$(this).attr('id')).hide();
                        });
                    });
                    
                    $(selector).on('shown.bs.popover', function (evt) {

                        $(this).addClass('sector-active');
                        var id = $(this).attr('id');
                        that.drawLine(id);
                    })

                    $(selector).on('hidden.bs.popover', function (evt) {
                        $(this).removeClass('sector-active');
                        var target = '#'+ $(this).attr('id')+'-connector';
                        if ($(target).length) {
                            $(target).remove();
                        }
                    })
                    
                    $(selector).hover(function() {
                        $(this).css('cursor','pointer');
                    });
                    
                } 
            }
        }
        
        //on resize
        window.addEventListener("resize", this.updatePopover.bind(this));        
    }
    
    drawLine(id)  {
        var style = this.popoverDatas['#'+id].style;
                        
        var svgObj = this.container.find('svg');

        var b1 = $('#'+id).find('#'+id+'-btn').get(0).getBBox();
        var b2 = $('.popover-'+ id).get(0).getBoundingClientRect();

        var b2x2 = b2.left + b2.width / 2;
        var b2y2 = b2.top + b2.height / 2;

        var svg = svgObj.get(0);

        var pt = svg.createSVGPoint();
        pt.x = b2x2;
        pt.y = b2y2;
        pt = pt.matrixTransform(svg.getScreenCTM().inverse());

        var newLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        newLine.setAttribute('id', id+'-connector');
        newLine.setAttribute('class', 'hd-sector-map__connector--color-'+style);
        newLine.setAttribute('x1', b1.x + (b1.width / 2));
        newLine.setAttribute('y1', b1.y + (b1.height / 2));
        newLine.setAttribute('x2', pt.x);
        newLine.setAttribute('y2', pt.y);
        newLine.setAttribute('style', 'stroke: black; stroke-width: 5;');

        $('#'+id).find('#'+id+'-btn').append(newLine);
    }
    
    updatePopover() {
        
        
        $('.sector-active').each(function() {
            bootstrap.Popover.getInstance('#'+$(this).attr('id')).hide();
        });
        
        for( var selector in this.popoverDatas) {
            
            var popover = bootstrap.Popover.getInstance(selector);
            var skidding = this.popoverDatas[selector]['offset'][0];
            var distance = this.popoverDatas[selector]['offset'][1];

            if (window.innerWidth <= 1366 && window.innerWidth > 1200 ) {
                skidding = skidding > 0 ?  skidding / 2 : 20;
                distance = distance > 0 ?  distance / 2 : 20;
            }
            
            if (window.innerWidth <= 1200) {
                skidding = 20;
                distance = 20;
            }
            
            popover._config.offset = [skidding,distance];
            popover.update();
        }

    }
};
